<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <img src="@/assets/images/pages/success.svg" alt="success" width="600" class="mx-auto mb-4 max-w-full">

      <template v-if="fromOnboarding">
        <h1 class="sm:mx-0 mt-5 mb-6 text-5xl d-theme-heading-color">¡Bienvenido!</h1>
        <h4 class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
          Hemos registrado tu información correctamente. En breve un asesor podrá contactarte.
        </h4>
        <vs-button size="large" to="/">Ir al panel</vs-button>
      </template>

      <template v-else>
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">Correo validado</h1>
        <h4 class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
          Hemos validado tu correo electrónico con éxito, inicia sesión para continuar.
        </h4>
        <vs-button size="large" to="/login">Iniciar sesión</vs-button>
      </template>
    </div>
  </div>
</template>

<script>
// =====================================================================
// Conversion-tracking constants — calibrados para Verificamex Firma.
// TODO(google-ads-firma): pedir a Negocio el conversion label dedicado para
//   Firma. Mientras tanto se reusa el de Identidad que ya estaba en el repo.
// TODO(meta-pixel-firma): si Negocio decide pixel separado para Firma,
//   cambiar GOOGLE_ADS_PIXEL_ID y/o el `fbq init`. Por ahora reusamos el
//   pixel actual con content_name distinto.
// =====================================================================
const GOOGLE_ADS_CONVERSION_ID = 'AW-462309740';
const GOOGLE_ADS_CONVERSION_LABEL_FIRMA = 'pvl6CMHb3dwZEOySudwB';
const META_CONTENT_NAME_FIRMA = 'Registro_exitoso_Firma_Calificado';
const GA4_METHOD_FIRMA = '[GA4]_Registro_exitoso_Firma_VBB';

function normalizeEmail(e) {
  if (!e) return '';
  const parts = e.trim().toLowerCase().split('@');
  if (parts.length !== 2) return e.trim().toLowerCase();
  return `${parts[0].replace(/\+.*$/, '')}@${parts[1]}`;
}

// Google Ads requires E.164 with leading "+": "+52XXXXXXXXXX"
function normalizePhoneGoogle(p) {
  let digits = (p || '').replace(/\D/g, '');
  if (digits.length === 10) digits = `52${digits}`;
  return digits ? `+${digits}` : '';
}

// Meta requires only digits: "52XXXXXXXXXX"
function normalizePhoneMeta(p) {
  let digits = (p || '').replace(/\D/g, '');
  if (digits.length === 10) digits = `52${digits}`;
  return digits;
}

export default {
  data() {
    return {
      fromOnboarding: false,
    };
  },
  mounted() {
    const q = this.$route.query || {};
    if (q.source === 'onboarding') {
      this.fromOnboarding = true;
      const cvrScore = parseFloat(q.cvr_score) || 0;
      const isKo = q.is_ko === '1' || q.is_ko === 'true';
      this.triggerConversionTracking(cvrScore, isKo);
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    triggerConversionTracking(cvrValue, isKo) {
      // Mantener comentado igual que Identidad — la decisión de filtrar KO
      // de las conversiones aún la debe tomar Negocio.
      // if (isKo) return;

      try {
        const me = (this.$store.state.account.user && this.$store.state.account.user.me) || {};
        const email = normalizeEmail(me.email);
        const phoneGoogle = normalizePhoneGoogle(me.phone);
        const phoneMeta = normalizePhoneMeta(me.phone);
        const userId = me.id != null ? String(me.id) : email;

        if (typeof window.gtag === 'function') {
          window.gtag('set', 'user_data', {
            email: email,
            phone_number: phoneGoogle,
          });
          window.gtag('event', 'conversion', {
            send_to: `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_CONVERSION_LABEL_FIRMA}`,
            value: cvrValue,
            currency: 'MXN',
            transaction_id: userId,
          });
          window.gtag('event', 'sign_up', {
            method: GA4_METHOD_FIRMA,
            user_id: email,
            phone_number: phoneGoogle,
          });
        }

        if (typeof window.fbq === 'function') {
          // Advanced Matching with email + phone for higher match rate.
          window.fbq('init', '1043065361169327', { em: email, ph: phoneMeta });
          window.fbq('track', 'CompleteRegistration', {
            content_name: META_CONTENT_NAME_FIRMA,
            currency: 'MXN',
            value: cvrValue,
            status: 'success',
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Conversion tracking failed:', e);
      }
    },
  },
};
</script>
